export default class UserUtil {

    static checkField(column) {
        let accessorKey = column.id;
        return !(accessorKey === 'id' ||
            accessorKey === 'middleName' || accessorKey === 'enabled' || accessorKey === 'birthday'
            || accessorKey === 'phoneNumber');
    }
}